import { module } from 'modujs';
import SmoothScroll from 'smooth-scroll';

export default class extends module {
    constructor(m) {
        super(m);

        this.anchors = [...document.querySelectorAll('[data-anchor="button"]')];
        this.activeButton = this.anchors[0];

        this.scroll = new SmoothScroll('a[href*="#"]', {
            offset: 80,
            speed: 500,
            speedAsDuration: true,
            easing: 'easeInOutCubic'
        });

        this.anchors.forEach(anchor => {
            anchor.addEventListener('click', this.handleClick.bind(this));
        });

        this.initObserver();
    }

    handleClick(e) {
        this.setActive(e.currentTarget);
    }

    setActive(button) {
        if (this.activeButton) {
            this.activeButton.classList.remove('active');
        }
        this.activeButton = button;
        this.activeButton.classList.add('active');
    }

    initObserver() {
        this.sections = this.anchors.map(anchor => {
            const link = anchor.querySelector('a');
            const href = link ? link.getAttribute('href') : null;
            return href ? document.querySelector(href) : null;
        }).filter(Boolean);

        const options = {
            root: null,
            rootMargin: '-80px 0px -80% 0px', // λίγο κάτω από το sticky nav (80px = offset σου)
            threshold: 0
        };

        this.observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    const index = this.sections.indexOf(entry.target);
                    if (index !== -1) {
                        this.setActive(this.anchors[index]);
                    }
                }
            });
        }, options);

        this.sections.forEach(section => this.observer.observe(section));
    }
    destroy() {
        // Cleanup όταν το module καταστρέφεται
        if (this.observer) {
            this.observer.disconnect();
        }
    }
}